// Disclaimer.jsx
import React from "react";

const Disclaimer = () => {
  return (
    <div className="page">
      <div className="disclaimer-box">
        <p>
          <strong>*Disclaimer:</strong> Results may vary from person to person.
          The effectiveness of this product depends on individual factors such
          as body chemistry, lifestyle, diet, and regular usage. Not everyone
          may experience the same results. Existing health conditions and
          personal body responses can affect how the product works. For best
          results, follow the recommended usage instructions and maintain a
          healthy lifestyle. If you have any medical conditions or concerns,
          consult a healthcare professional before use. Individual experiences
          may differ, so consistent use and patience are important.
        </p>
      </div>
    </div>
  );
};

export default Disclaimer;
